import { Injectable } from "@angular/core";
import { DocumentAiExtractionStatus } from "../../interfaces/document-category.interface";
import { PublicHttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PublicDocumentsService {
  constructor(private http: PublicHttpClientService) {}

  public getDocumentsByMetadata(id, resource_class, categories: Array<{ [key: string]: { [key: string]: any } }>) {
    const options = {
      resource_class,
      resource_id: id,
      categories,
    };
    return this.http
      .post("/api/public/documents/search_by_metadata", options)
      .pipe(tap((_) => console.log("PublicDocumentsService.getDocumentsByMetadata: Ok.")));
  }

  public postDocuments(documents, id, resource_class): Observable<any> {
    const options = {
      resource_class,
      resource_id: id,
      documents,
    };
    return this.http
      .post("/api/public/documents", options)
      .pipe(tap((_) => console.log("PublicDocumentsService.postDocuments: Ok.")));
  }

  public markAsDeletedFile(document_id: number | string, resource_id: string | number, resource_class = "Application") {
    const options = {
      params: {
        resource_id,
        resource_class,
      },
    };
    return this.http
      .delete(`/api/public/documents/${document_id}`, options)
      .pipe(tap((_) => console.log("PublicDocumentsService.markAsDeletedFile: Ok.")));
  }

  public postTextractPdf(content): Observable<any> {
    return this.http
      .post("/api/public/documents/textract_pdf", { content })
      .pipe(tap((_) => console.log("PublicDocumentsService.postTextractPdf: Ok.")));
  }

  public getDocumentsByStep(step: string | string[]): Observable<any> {
    const options = {
      params: {
        "step[]": step,
      },
    };
    return this.http
      .get("/api/public/documents/docs_by_step", options)
      .pipe(tap((_) => console.log("DocumentService.getDocumentsByStep: Ok.")));
  }

  public getDocuments(id: string, resource_class = "Application"): Observable<any> {
    const options = {
      params: {
        resource_class,
        resource_id: id,
      },
    };
    return this.http
      .get("/api/public/documents", options)
      .pipe(tap((_) => console.log("DocumentService.getDocuments: Ok.")));
  }

  public postDocument(
    doc: any,
    type,
    doc_string,
    id,
    resource_class = "Application",
    metadata: object = null,
    create_source = undefined
  ): Observable<any> {
    const options = {
      resource_class,
      resource_id: id,
      documents: [
        {
          category: doc.category,
          original_filename: doc.name,
          comments: "comment",
          content: doc_string,
          password: doc.password,
          metadata,
          create_source,
        },
      ],
    };
    return this.http
      .post("/api/public/documents", options)
      .pipe(tap((_) => console.log("DocumentService.postDocument: Ok.")));
  }

  public getDocumentProofsByCategory(category) {
    const options = {
      params: {
        category,
      },
    };
    return this.http
      .get("/api/public/documents/document_proofs_by_category", options)
      .pipe(tap((_) => console.log("DocumentService.getDocumentProofsByCategory: Ok.")));
  }

  public getDocumentsSpecification(): Observable<any> {
    return this.http
      .get("/api/public/documents/categories")
      .pipe(tap((_) => console.log("DocumentService.getDocumentsSpecification: Ok.")));
  }

  public getSentDocuments({
    id,
    in_status = undefined,
    categories = [],
    resource_class = "Application",
    section = undefined,
  }): Observable<any> {
    const options = {
      params: {
        in_status,
        "categories[]": categories,
        resource_id: id,
        resource_class,
        section,
      },
    };
    return this.http
      .get("/api/public/documents/in_status", options)
      .pipe(tap((_) => console.log("DocumentService.getSentDocuments: Ok.")));
  }

  public getVerifyBankAllowedDocuments() {
    return this.http
      .get("/api/public/documents/veryfi_banks_allowed")
      .pipe(tap((_) => console.log("DocumentService.getVerifyBankAllowedDocuments: Ok.")));
  }

  public getDocumentAiExtractionStatus(
    id: number | string,
    resource_id?: string | number | null,
    resource_class = "Application"
  ): Observable<DocumentAiExtractionStatus> {
    const params: { resource_id?: string | number; resource_class?: string } = {};
    if (resource_id != null && resource_id !== "") {
      params.resource_id = resource_id;
      params.resource_class = resource_class;
    }
    const options = { params };
    return this.http
      .get(`/api/public/documents/${id}/ai_extraction_status`, options)
      .pipe(tap((_) => console.log("PublicDocumentsService.getDocumentAiExtractionStatus: Ok.")));
  }

  public download(id: number | string, resource_id: string | number, resource_class = "Application"): Observable<Blob> {
    const options = {
      params: {
        resource_id,
        resource_class,
      },
      responseType: "blob" as "json",
    };
    return this.http
      .get(`/api/public/documents/${id}/download`, options)
      .pipe(tap((_) => console.log("PublicDocumentsService.download: Ok.")));
  }
}
